import React, { useState } from 'react';

import { CSSTransition } from 'react-transition-group';

import { CloseIcon } from 'assets/icons';
import useTabletCheck from 'hooks/useTabletCheck';

import styles from './InformationBoxWithBubble.module.scss';

const InformationBoxWithBubble = ({ children }: React.PropsWithChildren<{}>) => {
  const [showInfo, setShowInfo] = useState(false);
  const isTablet = useTabletCheck();

  return isTablet ? (
    <>
      <div
        className={styles.buttonContainer}
        onClick={() => {
          setShowInfo(!showInfo);
        }}
      >
        {!showInfo ? <p className={styles.infoIcon}>i</p> : <CloseIcon />}
      </div>
      <CSSTransition
        in={showInfo}
        timeout={400}
        classNames={{
          enter: styles.infoEnter,
          enterActive: styles.infoEnterActive,
          exit: styles.infoExit,
          exitActive: styles.infoExitActive,
        }}
        unmountOnExit
      >
        <div className={styles.infoMobileContainer}>{children}</div>
      </CSSTransition>
    </>
  ) : (
    <div className={styles.infoDesktopContainer}>{children}</div>
  );
};

export default InformationBoxWithBubble;
